<template>
  <v-form ref="form8">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold"
        >Wij hebben je antwoorden ontvangen</span
      >
      <span class="text-normal text-primary">Onze diëtisten zullen deze doornemen voor de intake. Binnen 5 werkdagen ontvang je de intake van ons.</span
      >
    </div>
  </v-form>
</template>

<script></script>
